import { render, staticRenderFns } from "./ArtistAvatarCarousel.vue?vue&type=template&id=91011df8&scoped=true"
import script from "./ArtistAvatarCarousel.vue?vue&type=script&lang=js"
export * from "./ArtistAvatarCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91011df8",
  null
  
)

export default component.exports